var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.74094 34.3917C9.83467 35.6325 10.3568 36.3565 11.8092 36.3277C21.9355 36.1638 24.5938 23.8864 18.3372 18.1106C17.3332 17.1877 16.1154 16.4264 14.6457 15.9118C13.9068 15.6501 12.6895 15.2729 11.6517 15.2729C10.7598 15.2729 10.0008 15.5553 9.80362 16.4442C9.43734 18.1416 9.60812 32.7081 9.74094 34.3917Z",
    fill: "url(#paint0_linear_1603_29072)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8693 3.8335C23.0545 3.8335 22.3691 4.0957 22.1869 4.90185C21.8528 6.4371 22.0138 19.665 22.1288 21.1985C22.2168 22.3186 22.6871 22.9747 24.0056 22.9563C33.2021 22.8016 35.6217 11.6552 29.9402 6.41237C29.0299 5.57402 27.9133 4.88345 26.5908 4.4177C25.9157 4.17677 24.8135 3.8335 23.8693 3.8335Z",
    fill: "url(#paint1_linear_1603_29072)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2594 16.8074C23.8316 18.7412 24.038 35.3558 24.1852 37.2838C24.2985 38.7011 24.8838 39.5159 26.5381 39.4918C38.1002 39.3066 41.1391 25.2967 34.0004 18.7061C32.8596 17.6544 31.4526 16.785 29.7903 16.2002C28.9427 15.8984 27.5524 15.4683 26.3736 15.4683C25.3513 15.4683 24.4807 15.792 24.2594 16.8074Z",
    fill: "url(#paint2_linear_1603_29072)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1603_29072",
    x1: 9.58301,
    y1: 36.3285,
    x2: 21.6958,
    y2: 36.3285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB292B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1603_29072",
    x1: 21.9845,
    y1: 23.1253,
    x2: 33.2004,
    y2: 23.1607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0462B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1603_29072",
    x1: 22.7847,
    y1: 41.8357,
    x2: 39.3484,
    y2: 41.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb46);
export default __webpack_public_path__ + "static/media/DB금융투자-46.1df551055de73e661226b82d8a00c3f0.svg";
export { ForwardRef as ReactComponent };